import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { organizationUnitsService } from '../api/organization-units.service';
import { ORGANIZATION_UNITS_KEYS } from './queryKeys';

export function useDeleteOrganizationUnit() {
  const queryClient = useQueryClient();
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (unitId: string) => organizationUnitsService.delete(unitId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ORGANIZATION_UNITS_KEYS.byOrg(activeOrganizationId!),
      });
    },
  });
}
